import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Wallet } from "lucide-react";
import { useWallet } from "../../context/WalletContext";

const CoinBar = ({ coins }) => {
const { walletData, loading } = useWallet ();


  return (
    <div className="col d-flex">
        <div className="coin-card position-relative overflow-hidden w-100 h-100 mb-0">
            <div className="glow glow-top"></div>
            <div className="glow glow-bottom"></div>

            <div className="wallet-icon">
                <Wallet size={22} strokeWidth={2.2} />
            </div>

            <h6 className="ft-13 fw-semibold mb-3">Available Balance</h6>

            <h1 className="coin-title fw-bold mb-4">
                {loading ? "Loading..." : `${walletData.balance} Coins`}
            </h1>

            <p className="coin-desc">
                Use coins to boost surveys & unlock premium actions.
            </p>

            <button className="buy-btn w-100 fw-bold">Buy Coins</button>

            <Link
                to="/my-wallet"
                className="wallet-history d-flex align-items-center justify-content-center gap-2 mt-4"
            >
                <span>View wallet history</span> <ArrowRight size={18} />
            </Link>
        </div>
     </div>
    );
}

export default CoinBar;